<!--
 * @Description: 混凝土订单
 * @Author: wangwangwang
 * @Date: 2020-11-13 14:42:48
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-11-14 10:44:48
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main style="display: flex">
        <div>
          <div class="header_right" @click="showCardNav = !showCardNav">
            <div class="title">搜索</div>
            <div>
              <transition name="from"></transition>
              <span v-show="!showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
              </span>
              <transition name="to"></transition>
              <span v-show="showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-up"></i>
              </span>
            </div>
          </div>
          <div v-show="showCardNav" class="hr"></div>
          <el-collapse-transition>
            <div v-show="showCardNav">
              <div class="search">
                <span style="display: inline-block; margin-bottom: 10px">
                  <span style="margin-right: 12px">订单编号</span>
                  <el-input v-model="tableParam.orderNo" style="width: 240px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">工程名称</span>
                  <el-input v-model="tableParam.engineeringName" style="width: 240px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">浇筑时间</span>
                  <el-date-picker v-model="tableParam.pouringTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"></el-date-picker>
                </span>
                <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="card">
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
                <el-table-column align="center" type="selection"></el-table-column>
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width">
                    <template slot-scope="scope">
                      <!-- <el-button v-if="item.label == '运输罐车'" class="bottom_one" size="mini" @click="handleAddTankCar(scope.row)">

                        添加
                      </el-button> -->
                      <div v-if="item.label == '浇筑方式'">
                        <div>{{ scope.row.pouringMethod | pouringMethodFilter }}</div>
                      </div>
                      <el-button v-else-if="item.label == '运输详情'" class="bottom_one" size="mini" @click="handleViewTansferDetail(scope.row)"> 查看 </el-button>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
            <div class="card_bottom">
              <div class="card_bottom_left">
                <div class="top_page_totle">总共{{ total }}条</div>
                <el-pagination
                  :current-page.sync="tableParam.page"
                  :page-size="tableParam.pageSize"
                  :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
                  layout="prev,pager,sizes,next,jumper"
                  :total="total"
                  @size-change="sizeChange"
                  @current-change="gettableData()"
                ></el-pagination>
              </div>
              <div>
                <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>

    <!-- 添加运输罐车 -->
    <el-dialog v-dialogDrag :visible.sync="addDialog" width="420px" :close-on-click-modal="false" :before-close="() => (addDialog = false)">
      <span slot="title" class="dialog-title">添加运输</span>
      <!-- <div class="dialoginfo">
        <el-form ref="reffromDate" :inline="true" label-width="110px">
          <el-form-item prop="code">
            <span slot="label" style="color: #ff0000">选择罐车</span>
            <el-select ref="selection3" v-model="selectedRankCarNos" multiple filterable allow-create default-first-option placeholder="请选择">
              <el-option v-for="item in rankCarList" :key="item.plateNumber" :label="item.plateNumber" :value="item.plateNumber"></el-option>
            </el-select>
          </el-form-item>
          <div>
            已选择罐车：
            <div v-for="item in selectedRankCarNos" :key="item">{{item}}</div>
          </div>
        </el-form>
      </div> -->
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px" class="demo-ruleForm">
        <el-form-item label="车牌号：" prop="carNo">
          <!-- <el-select v-model="ruleForm.carNo" placeholder="请选择活动区域">
            <el-option v-for="item in rankCarList" :key="item.plateNumber" :label="item.plateNumber" :value="item.plateNumber"></el-option>
          </el-select> -->
          <el-input v-model="ruleForm.carNo" :rows="5" resize="none" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item prop="proLine" label="生产线">
          <el-select ref="queueUpLineGroup" v-model="ruleForm.proLine" style="width: 240px" placeholder="请选择" filterable @change="
                $nextTick(() => {
                  ruleForm.proLineName = $refs.queueUpLineGroup.selectedLabel;
                })
                ">
            <el-option v-for="item in lineList" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="生产时间：" prop="proTime">
          <el-date-picker v-model="ruleForm.proTime" type="datetime" value-format="yyyy-MM-dd HH:MM:ss" placeholder="请选择时间"> </el-date-picker>
        </el-form-item>
        <el-form-item label="票面量（方）：" prop="proNum">
          <el-input v-model="ruleForm.proNum" type="number" @blur="calcSign()"></el-input>
        </el-form-item>
        <!-- <el-form-item label="运输距离(km)：" prop="transportDistance">
          <el-input v-model="ruleForm.transportDistance" type="number"></el-input>
        </el-form-item> -->
        <el-form-item label="余料量（方）：" prop="residueNum">
          <el-input v-model="ruleForm.residueNum" type="number" @blur="calcSign()"></el-input>
        </el-form-item>
        <el-form-item label="签收量（方）：" prop="signForNum">
          <span>{{ ruleForm.signForNum }}</span>
        </el-form-item>
        <el-form-item prop="productName" label="特殊产品">
            <el-select ref="productName" v-model="ruleForm.productName" placeholder="请选择" filterable>
              <el-option v-for="item in productList" :key="item.productName" :label="item.productName" :value="item.productName"></el-option>
            </el-select>
          </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button class="bottom_all" style="margin-left: 24px" @click="submitFromDate('ruleForm')">保 存</el-button>
      </span>
    </el-dialog>

    <el-dialog v-dialogDrag :visible.sync="isShowTansferRecord" width="75%" :close-on-click-modal="false" :before-close="resetFromDate">
      <span slot="title" class="dialog-title">查看运输记录</span>
      <div class="dialoginfo">
        <el-row v-if="curRow" type="flex" align="middle">
          <el-col :span="6">工程名称：{{ curRow.engineeringName }}</el-col>
          <el-col :span="6">订单号：{{ curRow.orderNo }}</el-col>
          <el-col :span="6">产品名称：{{ curRow.productName }}</el-col>
          <el-col :span="6">
            <el-button class="bottom_all" size="mini" @click="handleAddTankCar()">添加运输</el-button>
          </el-col>
        </el-row>
      </div>
      <el-table :data="transferList" style="width: 100%">
        <el-table-column prop="structuralParts" label="生产单位"></el-table-column>
        <el-table-column prop="proLineName" label="生产线"></el-table-column>
        <el-table-column prop="code" label="运输号"></el-table-column>
        <el-table-column prop="carNo" label="车牌号"></el-table-column>
        <el-table-column prop="proTime" label="生产时间"></el-table-column>
        <el-table-column prop="proNum" label="票面量(方)"></el-table-column>
        <el-table-column prop="residueNum" label="余料量(方)"></el-table-column>
        <el-table-column prop="signForNum" label="使用量(方)"></el-table-column>
        <el-table-column prop="transportDistance" label="运输距离"></el-table-column>
        <el-table-column prop="dataStatus" label="状态"></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button class="bottom_one" size="mini" @click="handleAddTankCar(scope.row, scope.$index)"> 详情 </el-button>
            <el-button class="bottom_one" style="margin-left: 5px" size="mini" @click="print(scope.row)"> 打印 </el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetFromDate">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 打印弹窗 -->
    <el-dialog v-dialogDrag :visible.sync="printDig" width="950px">
      <span slot="title" class="dialog-title">司机小票</span>
      <div class="dialoginfo">
        <div>
          <el-card id="dy" shadow="always">
            <div class="top">
              <div>四川华西绿舍建材有限公司</div>
              <div>商品混凝土供货单 <small>No:</small><img :src="printList.codeUrl" alt="" /></div>
              <div>
                <span>发货时间：</span>
                <span>流水号：</span>
              </div>
            </div>
            <div class="table">
              <div class="div1">
                <div>
                  <span>项目名称：{{ printList.engineeringName }}</span>
                </div>
                <div>
                  <span>签收人：</span>
                </div>
              </div>
              <div class="div1">
                <div>
                  <span>浇筑部位：{{ printList.structuralParts }}</span>
                </div>
                <div>
                  <span>砼标号：{{ printList.label }}</span>
                </div>
              </div>
              <div class="div2">
                <div>浇筑方式</div>
                <div>{{ printList.pouringMethod }}</div>
                <div>本车数量(m3)</div>
                <div>{{ printList.faceValue }}</div>
                <div>累计车数</div>
                <div>{{ printList.cumulativeTrains }}</div>
              </div>
              <div class="div2">
                <div>车牌号</div>
                <div>{{ printList.carNo }}</div>
                <div>发货人</div>
                <div></div>
                <div>进泵时间</div>
                <div></div>
              </div>
              <div class="div2">
                <div>司机</div>
                <div></div>
                <div>泵工签字</div>
                <div></div>
                <div>离泵时间</div>
                <div></div>
              </div>
              <div class="div2">
                <div>高度/臂长</div>
                <div></div>
                <div>搅拌站点</div>
                <div></div>
                <div>小方量运输补差</div>
                <div></div>
              </div>
              <div class="div3">
                <div>备注：</div>
                <div></div>
              </div>
              <div class="div4">
                <div>
                  <i class="el-icon-warning" style="font-size: 30px"></i>
                </div>
                <div>
                  <div>1、请认真复核票面信息，做好交货检验，验收合格后方可签收、浇筑。</div>
                  <div>2、预拌混凝土送到后，严禁加水，请及时浇筑；请按照规范要求组织实验浇筑、振捣、养护、拆模工作。</div>
                  <div>3、请施工单位高度重视上述工作，因上述工作不符合要求而导致的质量问题我司概不负责。</div>
                </div>
              </div>
            </div>
            <div class="bottom">
              <span>服务投诉电话：</span>
              <span>技术服务电话：</span>
              <span>站内调度电话：</span>
            </div>
          </el-card>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        指定打印模板：
        <el-select v-model="printIndex">
          <el-option v-for="(item, index) in printTemplateList" :key="index" :value="item.templateId" :label="item.templateName"></el-option>
        </el-select>
        <el-button class="bottom_all_two" @click="printDig = false">关 闭</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="doPrint()">打 印</el-button>
      </span>
    </el-dialog>
    <!-- 打印组件 -->
    <Printer v-if="curRow" ref="printer" :data="printList" :firstKey="'concreteCarTicketMain'" :secondKey="'concreteDriverTicket'" :stationId="curRow.stationId" :userSelectIndex="printIndex" @confList="getPrintTemplate"></Printer>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
// import { queryPage, WXqueryCarriageList, WXgetTankercarList, queryAllByplanId, saveTankCar } from "@/api/basicConfig/concreteOrder.js";
import { driverReceipts } from "@/api/smart/schedul/j.js";
import {
  queryProduct,
} from "@/api/basicConfig/proflow.js";
import { queryPage, WXqueryCarriageList, WXgetTankercarList, saveDispatchLogisticsOrder } from "@/api/basicConfig/concreteOrder.js";
import { queryLineByStation } from "@/api/smart/productTransport_outside.js";
import Printer from "@/views/components/Printer.vue";
export default {
  mixins: [mixin],
  components: {
    Printer,
  },
  data() {
    return {
      queryPage: queryPage,
      table: [
        { label: "订单编号", width: "auto", prop: "orderNo", status: true },
        { label: "产品名称", width: "auto", prop: "productName", status: true }, // 需要分解
        { label: "生产量(方)", width: "auto", prop: "pouringNum", status: true },
        { label: "浇筑时间", width: "auto", prop: "pouringTime", status: true },
        { label: "浇筑方式", width: "auto", prop: "pouringMethod", status: true },
        { label: "工程名称", width: "auto", prop: "engineeringName", status: true },
        { label: "施工单位", width: "auto", prop: "roadwork", status: true },
        { label: "工程地址", width: "150", prop: "place", status: true },
        { label: "联系人", width: "150", prop: "person", status: true },
        { label: "联系电话", width: "150", prop: "phoneNum", status: true },
        // { label: "运输罐车", width: "150", prop: "", status: true },
        { label: "运输详情", width: "150", prop: "", status: true },
      ],
      /*列表选中的数据集*/
      tableParam: {
        page: 1,
        pageSize: 10,
        code: "",
        name: "",
      },
      total: 0,
      pagesType: 0,
      fromDate: {
        code: "",
      },
      supplierInfo: null,

      selectedRankCarNos: "",
      rankCarList: [],
      selectedRankCarList: [],
      curRow: null,
      isShowTansferRecord: false,
      transferList: [],
      printTemplateList: [],
      printIndex: null,
      isPrint: true,
      printList: "",
      printDig: false,
      indexPrint: null,
      ruleForm: {
        carNo: null,
        proTime: null,
        proNum: null,
        transportDistance: null,
        residueNum: null,
        signForNum: null,
        templateId: null,
        proLine: null,
        proLineName:null,
      },
      lineList: [],
      rules: {
        carNo: [{ required: true, message: "请选择车牌号", trigger: "change" }],
        proLine: [{ required: true, message: "请选择生产线", trigger: "change" }],
        proTime: [{ required: true, message: "请选择生产时间", trigger: "change" }],
        proNum: [{ required: true, message: "请输入", trigger: "blur" }],
        transportDistance: [{ required: true, message: "请输入", trigger: "blur" }],
        residueNum: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      productList:[],
    };
  },
  created() {
    this.tableParam = { ...this.tableParam, engineeringName: "", orderNo: "", pouringTime: "" };
    this.gettableData();
  },
  methods: {
    /*重置数据*/
    init() {
      this.gettableData();
    },
    pagessubmitFromDate() {
      let _this = this;
      _this.$refs.reffromDate.validate(valid => {
        if (valid) {
          _this.submitFromDate();
        } else {
          return false;
        }
      });
    },
    handleAddTankCar(row, index) {
      this.indexPrint = index;
      // 获取罐车列表
      WXgetTankercarList({ contractId: this.curRow.contractId }).then(res => {
        this.rankCarList = res.data;
      });
      // 获取生产线
      queryLineByStation({ stationId: this.stationId }).then(res => {
        if (res.code == 1001) {
          this.lineList = res.data;
        }
      });
      //获取特殊产品
      queryProduct({stationId:this.stationId}).then(res => {
        if(res.code == 1001) {
          this.productList = res.data
        }
      })
      if (row) {
        this.ruleForm = {
          id: row.id,
          carNo: row.carNo,
          proTime: row.proTime,
          productName:row.productName,
          proNum: row.proNum.toFixed(2),
          transportDistance: row.transportDistance,
          residueNum: row.residueNum.toFixed(2),
          signForNum: row.signForNum.toFixed(2),
          proLine:row.proLine,
          proLineName:row.proLineName,
        };
        this.printIndex = row.templateId;
        this.isPrint = false;
      } else {
        this.ruleForm = this.$options.data().ruleForm;
      }
      this.addDialog = true;
    },
    // 计算使用量
    calcSign() {
      if (this.ruleForm.proNum) {
        this.ruleForm.proNum = (this.ruleForm.proNum * 1).toFixed(2);
      }
      if (this.ruleForm.residueNum) {
        this.ruleForm.residueNum = (this.ruleForm.residueNum * 1).toFixed(2);
      }
      if (this.ruleForm.proNum && this.ruleForm.residueNum) {
        this.ruleForm.signForNum = (this.ruleForm.proNum * 1 - this.ruleForm.residueNum * 1).toFixed(2);
      }
      this.$forceUpdate();
    },
    submitFromDate(ruleForm) {
      // saveTankCar({ planId: this.curRow.id, carNo: this.selectedRankCarNos.join(',') }).then(res => {
      //   console.log(res)
      //   this.addDialog = false;
      // })
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          this.ruleForm.templateId = this.printIndex;
          const params = {
            // id: id? id: null,
            planId: this.curRow.id,
            productionSiteId: this.curRow.stationId,
            ...this.ruleForm,
          };
          saveDispatchLogisticsOrder(params).then(res => {
            if (res.code === 1001) {
              this.transferList = [];
              WXqueryCarriageList({ planId: this.curRow.id }).then(res2 => {
                res2.data.forEach(el => {
                  el.structuralParts = this.curRow.roadwork;
                  this.transferList.push(el);
                });
                this.isPrint = false;
                this.addDialog = false;
              });
            }
          });
        }
      });
    },
    getPrintTemplate(list) {
      this.printTemplateList = list;

      //整理conditionList和模板id
      let conditionDes = [];
      let conditionObj = {};
      list.forEach(item => {
        const data = item;
        conditionObj.stationTemplateId = item.stationTemplateId;
        console.log(data.conditionList);
        if (item.conditionList && item.conditionList.length !== 0) {
          item.conditionList.forEach(ite => {
            conditionObj[ite.conditionName] = ite.conditionData;
          });
        }
        conditionDes.push(conditionObj);
      });
      //对比conditionDes和this.formData
      let checkSame = condition => {
        let a = condition.find(item => {
          //不考虑["stationTemplateId","brand","originPlace","transportUnit"]这些属性是否相同
          let a = Object.keys(item).filter(item => !["stationTemplateId", "brand", "originPlace", "transportUnit"].find(ite => item == ite));
          //判断剩下的属性值是否和low的相同
          let sameLength = 0;
          a.forEach(ite => {
            if (ite == "isFirstSupply") {
              let isFirstSupply = this.curRow[ite] == 1 ? "Y" : "N";
              if (item[ite] === isFirstSupply) {
                sameLength++;
              }
            } else {
              if (item[ite] === this.curRow[ite]) {
                sameLength++;
              }
            }
          });
          //找出low和condition属性全部相同的哪个对象并返回id
          return sameLength == a.length;
        });
        if (a == undefined) {
          return 0;
        }
        return a.stationTemplateId;
      };
      if (!this.printIndex) {
        if (checkSame(conditionDes) != 0) {
          let marryTemplate = list.find(item => item.stationTemplateId == checkSame(conditionDes));
          this.printIndex = marryTemplate.templateId;
        } else {
          this.printIndex = list[0].templateId;
        }
      }
    },
    handleViewTansferDetail(item) {
      this.curRow = item;
      this.transferList = [];
      this.stationId = item.stationId;
      WXqueryCarriageList({ planId: item.id }).then(res => {
        res.data.forEach(el => {
          el.structuralParts = item.roadwork;
          this.transferList.push(el);
        });
      });
      this.isShowTansferRecord = true;
    },
    resetFromDate() {
      this.isShowTansferRecord = false;
    },
    print(row) {
      let that = this;
      driverReceipts({ code: row.code }).then(res => {
        if (res.code == 1001) {
          that.printList = res.data;
          that.printList.codeUrl = "file/" + that.printList.codeUrl;
          this.printDig = true;
        }
      });
    },
    doPrint() {
      this.$refs["printer"].print();
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
  filters: {
    pouringMethodFilter(e) {
      if (e) {
        e = JSON.parse(e);
        let table = e.map(res => res.name);
        let text = table.join("、");
        return text;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}
.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
#dy {
  padding: 15px;

  .el-card__body {
    border: 1px solid #ccc;
    padding: 35px;

    .top {
      > div:nth-of-type(1) {
        font-size: 26px;
        font-weight: 600;
        text-align: center;
      }

      > div:nth-of-type(2) {
        padding-top: 10px;
        font-size: 18px;
        font-weight: 600;
        text-align: center;
        position: relative;

        > small {
          position: absolute;
          left: 535px;
          top: 15px;
          font-weight: 100;
          font-size: 14px;
        }

        > img {
          width: 80px;
          position: absolute;
          right: 0px;
          top: -25px;
        }
      }

      > div:nth-of-type(3) {
        padding: 5px 0 5px 0;

        > span {
          font-size: 14px;
          width: 350px;
          display: inline-block;
        }
      }
    }

    .table {
      border: 1px solid #ccc;

      .div1 {
        display: flex;
        min-height: 55px;

        > div:nth-of-type(1) {
          width: 490px;
          flex: none;
          border-right: 1px solid #ccc;
          border-bottom: 1px solid #ccc;
          padding: 17px 5px;
        }

        > div:nth-of-type(2) {
          flex: 1;
          border-bottom: 1px solid #ccc;
          padding: 17px 5px;
        }
      }

      .div2 {
        font-size: 13px;
        display: flex;
        min-height: 30px;

        > div:nth-child(odd) {
          width: 110px;
          flex: none;
          border-right: 1px solid #ccc;
          border-bottom: 1px solid #ccc;
          padding: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        > div:nth-child(even) {
          width: 165px;
          flex: none;
          border-right: 1px solid #ccc;
          border-bottom: 1px solid #ccc;
          padding: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        > div:nth-of-type(4) {
          width: 105px;
          flex: none;
        }
      }

      .div3 {
        font-size: 13px;
        min-height: 30px;
        display: flex;

        > div:nth-of-type(1) {
          width: 110px;
          flex: none;
          border-right: 1px solid #ccc;
          border-bottom: 1px solid #ccc;
          padding: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        > div:nth-of-type(2) {
          flex: 1;
          border-bottom: 1px solid #ccc;
          padding: 5px;
          display: flex;
          align-items: center;
        }
      }

      .div4 {
        font-size: 13px;
        min-height: 30px;
        display: flex;

        > div:nth-of-type(1) {
          width: 110px;
          flex: none;
          border-right: 1px solid #ccc;
          border-bottom: 1px solid #ccc;
          padding: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        > div:nth-of-type(2) {
          flex: 1;
          border-bottom: 1px solid #ccc;
          padding: 5px;
        }
      }
    }

    .bottom {
      margin: 10px 10px;

      > span {
        display: inline-block;
        width: 245px;
      }
    }
  }
}
</style>
